// Availability.js
import axiosInstance from '@/lib/axios';

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  const tokenType = localStorage.getItem('tokenType');
  return {
    'Authorization': `${tokenType} ${token}`,
    'Content-Type': 'application/json',
  };
};



export async function availabilityPOST(data) {
  try {
    const response = await axiosInstance.post('/users/availability', data);
    return response.data;
  } catch (error) {
    // Axios errors might be in error.response.data or just error.message
    if (error.response) {
      throw new Error(error.response.data || 'Request failed');
    } else {
      throw new Error(error.message);
    }
  }
}



export async function availabilityGET() {
  try {
    const response = await axiosInstance.get('/users/availability');
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data || 'Request failed');
    } else {
      throw new Error(error.message);
    }
  }
}

export async function availabilityDELETE(data) {
  try {
    const response = await axiosInstance.delete('/users/availability', { data });
    // Axios returns 204 status with empty data automatically
    return response.status === 204 ? null : response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data || 'Request failed');
    } else {
      throw new Error(error.message);
    }
  }
}